// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Yz-V3","requiredAsterisk":"Info_requiredAsterisk__2_NNI"};